export default import.meta.glob('~~/common/aw_icons/src/forms/*.svg', { query: '?raw', import: 'default', eager: true });
